<app-layout>
    <mat-toolbar class="page-header" role="heading">
        <h1>{{ 'GoalsReport' | translate: {Default: "Goals Report"} }}</h1>
    </mat-toolbar>

    <div class="content">
        <app-goals-details-data-grid></app-goals-details-data-grid>
    </div>
</app-layout>
